/*
 *
 * Package: `@dbh/div-with-background-theme`.
 *
 */const THEME_KEY_DIV_WITH_BACKGROUND="divWithBackground";const modifyDivWithBackgroundTheme=a=>{const{colors:{white:b}}=a;return {...a,[THEME_KEY_DIV_WITH_BACKGROUND]:{backgroundRepeat:"no-repeat",backgroundSize:"cover",backgroundPosition:"center center",backgroundColor:b,s:{height:"15rem"},m:{height:"18.5rem"},l:{height:"20rem"},xl:{height:"24rem"},xxl:{height:"45rem"},xxxl:{height:"70rem"},desktop:{maxHeight:void 0,height:void 0},mobile:{maxHeight:void 0,height:void 0}}}};

export { THEME_KEY_DIV_WITH_BACKGROUND, modifyDivWithBackgroundTheme as default };
